export default __webpack_public_path__ + "static/media/mars.0fb900ff.svg";